import UnitCard from './unit-card'

export default UnitCard
